module.exports = __webpack_public_path__ + "26e8891c3876a376f01bfc40e6d0235a.glb";